// Применения утеплителя: 18 групп справочника поверх значений, которые лежат
// в колонке «Для аналогии у утеплителя».
//
// Список групп — это будущая таблица insulation_applications: 17 значений из
// выгрузки PIM плюс «Техническая изоляция», которой в PIM нет, а в guide она
// стоит у 825 позиций. Ключ группы совпадает с колонкой `code` справочника,
// поэтому когда связи переедут в guide_insulation_application, список приедет
// с сервера, а весь остальной код подбора останется как есть.
//
// Пока переезда не случилось, колонка содержит старые написания, и в `matches`
// лежат оба набора: и новые формулировки справочника, и то, как это писали
// раньше («полы по лагам» и «Для пола»). Так фильтр работает и на сегодняшних
// данных, и на переписанных, без дня простоя посередине.
//
// Про запятую внутри названия. Строка колонки режется по запятой, а шесть
// названий справочника запятую содержат сами («Стены, перегородки»). Поэтому
// у таких групп в `matches` перечислены половинки — «стены» и «перегородки»
// по отдельности. Ни одна половинка не встречается в двух группах, так что
// разбор однозначен.
//
// Два правила, которые держат словарь честным:
//
//   1. Значение из базы, не попавшее ни в одну группу, не теряется — оно уходит
//      в «Прочие применения» и показывается менеджеру как есть. Пропуск в словаре
//      виден на экране, а не молча съедает товары.
//   2. Строки без применения собираются в «Применение не указано». Сегодня там
//      весь ЭППС: у всех 561 строки экструдированного пенополистирола и ППС эта
//      колонка пуста. Когда её заполнят, строки уйдут в свои группы сами —
//      править здесь ничего не нужно.

/** Строки без применения. */
export const NO_APPLICATION_KEY = "__none__";

/** Значения, которых нет в словаре. */
export const OTHER_KEY = "__other__";

export const NO_APPLICATION_LABEL = "Применение не указано";
export const OTHER_LABEL = "Прочие применения";

// Порядок — как в справочнике, по алфавиту.
export const APPLICATION_GROUPS = [
  {
    key: "balcony",
    label: "Балконы и лоджии",
    matches: ["балконы и лоджии", "Для балкона/лоджии"],
  },
  {
    key: "sound",
    label: "Звукоизоляция, шумоизоляция",
    matches: ["звукоизоляция", "шумоизоляция"],
  },
  {
    key: "fireproof",
    label: "Изоляция конструкций и оборудования от высоких температур, огнезащита",
    matches: ["изоляция конструкций и оборудования от высоких температур", "огнезащита"],
  },
  {
    key: "frameWalls",
    label: "Каркасные стены и перегородки",
    matches: ["каркасные стены и перегородки", "Для перегородок"],
  },
  {
    key: "pitchedRoof",
    label: "Кровли скатные/мансардные",
    matches: ["кровли скатные/мансардные", "Для кровли", "Для мансарды"],
  },
  {
    key: "roads",
    label: "Отмостки, садовые дорожки, дорожное строительство",
    matches: ["отмостки", "садовые дорожки", "дорожное строительство"],
  },
  {
    // «Плоские кровли» без уточнений нагружаемость не различают, поэтому общее
    // значение входит во все три группы плоских кровель.
    key: "flatRoofLoaded",
    label: "Плоские кровли (утепление нагружаемых кровель и конструкций)",
    matches: [
      "плоские кровли (утепление нагружаемых кровель и конструкций)",
      "плоские кровли (утепление нагружаемых кровель)",
      "плоские кровли",
    ],
  },
  {
    key: "flatRoofUnused",
    label: "Плоские неэксплуатируемые кровли",
    matches: ["плоские неэксплуатируемые кровли", "плоские кровли"],
  },
  {
    key: "flatRoofUsed",
    label: "Плоские эксплуатируемые кровли (нагружаемые)",
    matches: ["плоские эксплуатируемые кровли (нагружаемые)", "плоские кровли"],
  },
  {
    // В guide писали «под стяжку», в справочнике «под стяжкой» — оба написания.
    key: "floorOnGround",
    label: "Полы по грунту, утепление под стяжкой пола",
    matches: [
      "полы по грунту",
      "утепление под стяжкой пола",
      "утепление под стяжку пола",
      "Для пола",
    ],
  },
  {
    key: "floorOnJoists",
    label: "Полы по лагам, перекрытия (ненагружаемые конструкции)",
    matches: [
      "полы по лагам",
      "перекрытия (ненагружаемые конструкции)",
      "перекрытия",
      "Для перекрытий",
    ],
  },
  {
    // «Для фасада» не уточняет систему, поэтому стоит и здесь, и в штукатурном.
    key: "ventFacade",
    label: "Система вентилируемых фасадов",
    matches: ["система вентилируемых фасадов", "навесные фасады с подсистемой", "Для фасада"],
  },
  {
    key: "walls",
    label: "Стены, перегородки",
    matches: ["стены", "перегородки", "Для стен"],
  },
  {
    key: "sandwich",
    label: "Сэндвич",
    matches: ["сэндвич"],
  },
  {
    // Одно значение на три пункта задания: высокие температуры, промышленное
    // оборудование и трубопроводы «техническая изоляция» между собой не делит,
    // и в выгрузке PIM такого деления тоже нет. Поэтому в справочнике это одна
    // строка, а не три.
    key: "techInsulation",
    label: "Техническая изоляция",
    matches: ["техническая изоляция", "Для труб", "Для вентиляции"],
  },
  {
    key: "bath",
    label: "Утепление бань и саун",
    matches: ["утепление бань и саун", "Для бани"],
  },
  {
    key: "foundation",
    label: "Фундаменты и цоколи",
    matches: ["фундаменты и цоколи", "Для фундамента/цоколя"],
  },
  {
    key: "plasterFacade",
    label: "Штукатурный фасад",
    matches: ["штукатурный фасад", "Под штукатурку", "Для фасада"],
  },
];

// Регистр и лишние пробелы в колонке гуляют: «плоские кровли» и «Плоские кровли»
// — одно значение, и сводит их к одному ключу именно нормализация.
const normalize = (value) => String(value || "").trim().toLowerCase().replace(/\s+/g, " ");

// Значение из базы -> ключи групп, в которые оно входит. Собирается один раз.
const GROUPS_BY_VALUE = (() => {
  const index = new Map();
  APPLICATION_GROUPS.forEach((group) => {
    group.matches.forEach((match) => {
      const key = normalize(match);
      if (!index.has(key)) index.set(key, []);
      index.get(key).push(group.key);
    });
  });
  return index;
})();

/** Разбирает колонку «Для аналогии у утеплителя» в список значений. */
export const splitApplications = (raw) => String(raw || "")
  .split(",")
  .map((item) => item.trim())
  .filter(Boolean);

/**
 * Ключи групп, к которым относится строка каталога.
 *
 * Пустая колонка даёт NO_APPLICATION_KEY, незнакомое значение — OTHER_KEY.
 * Обе ветки попадают в фильтр наравне с остальными, поэтому ни одна строка
 * каталога не исчезает из-за неполного словаря.
 */
export const groupKeysForRow = (raw) => {
  const values = splitApplications(raw);
  if (values.length === 0) {
    return [NO_APPLICATION_KEY];
  }

  const keys = new Set();
  values.forEach((value) => {
    const matched = GROUPS_BY_VALUE.get(normalize(value));
    if (matched) {
      matched.forEach((key) => keys.add(key));
    } else {
      keys.add(OTHER_KEY);
    }
  });

  return [...keys];
};

/** Значения из базы, которых нет в словаре, — чтобы показать их менеджеру как есть. */
export const unmappedApplications = (rows) => {
  const seen = new Map();
  (rows || []).forEach((row) => {
    splitApplications(row && row.analogy).forEach((value) => {
      if (GROUPS_BY_VALUE.has(normalize(value))) return;
      const key = normalize(value);
      seen.set(key, (seen.get(key) || 0) + 1);
    });
  });
  return [...seen.entries()]
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => b.count - a.count);
};

/**
 * Группы строки каталога: берём уже посчитанные, если они есть.
 *
 * Строки подбора приходят из buildPickerRows с готовым applicationKeys и
 * исходного поля «Для аналогии у утеплителя» при себе не несут. Разбирать
 * несуществующий row.analogy — значит посчитать каждую строку как «применение
 * не указано» и обнулить счётчики у всех пунктов фильтра, а заодно погасить
 * их: пункт с нулём на экране заблокирован.
 */
const applicationKeysOf = (row) => (
  Array.isArray(row && row.applicationKeys)
    ? row.applicationKeys
    : groupKeysForRow(row && row.analogy)
);

/**
 * Пункты фильтра «по применению» вместе с числом подходящих строк.
 *
 * Группы задания идут в его порядке и остаются в списке даже пустыми — иначе
 * не видно, что про применение спрашивали, а товаров под него нет. «Прочие» и
 * «без применения» добавляются в конец, только если строки для них есть.
 */
export const buildApplicationOptions = (rows) => {
  const counts = new Map();
  (rows || []).forEach((row) => {
    applicationKeysOf(row).forEach((key) => {
      counts.set(key, (counts.get(key) || 0) + 1);
    });
  });

  const options = APPLICATION_GROUPS.map((group) => ({
    key: group.key,
    label: group.label,
    count: counts.get(group.key) || 0,
  }));

  [
    { key: OTHER_KEY, label: OTHER_LABEL },
    { key: NO_APPLICATION_KEY, label: NO_APPLICATION_LABEL },
  ].forEach((extra) => {
    const count = counts.get(extra.key) || 0;
    if (count > 0) {
      options.push({ ...extra, count });
    }
  });

  return options;
};

/**
 * Применения строки в виде, пригодном для сравнения двух товаров между собой.
 *
 * Нужно поиску аналогов: он сопоставляет применения выбранного товара и
 * кандидата. Сравнивать сами строки колонки нельзя — одно и то же применение
 * написано в базе по-разному («плоские кровли» и «Плоские кровли», «Для бани»
 * и «утепление бань и саун»), и пока колонку переписывают на названия
 * справочника, у двух товаров какое-то время стоят разные написания одного и
 * того же. Сравнение впритык молча перестало бы находить аналоги.
 *
 * Строки без применения не дают ключей вовсе. Иначе два товара с пустой
 * колонкой совпали бы друг с другом, а у стекловолокна применения —
 * единственный критерий отбора, и в аналоги уехал бы весь ЭППС, у которого
 * колонка пуста целиком.
 *
 * Незнакомое значение не выбрасывается, а сравнивается как текст: два товара
 * с одинаковым непонятным применением — аналоги, с разными — нет. Ровно так
 * это работало до словаря, и пропуск в словаре не должен менять отбор.
 */
export const applicationMatchKeys = (raw) => {
  const keys = new Set();

  splitApplications(raw).forEach((value) => {
    groupKeysForRow(value).forEach((key) => {
      if (key === NO_APPLICATION_KEY) return;
      keys.add(key === OTHER_KEY ? `${OTHER_KEY}:${normalize(value)}` : key);
    });
  });

  return [...keys];
};

/** Есть ли у двух товаров хоть одно общее применение. */
export const shareApplication = (left, right) => {
  const leftKeys = new Set(applicationMatchKeys(left));
  return applicationMatchKeys(right).some((key) => leftKeys.has(key));
};

export default APPLICATION_GROUPS;
